/**
 * Created by wangmc on 2017/11/21.
 */

// 自动分析域名后缀
export const domain = ((domain) => {
    var ares = domain.split(':')[0].split('.')
    ares.shift()
    ares.unshift('')
    return ares.join('.')
})(document.domain)

export const sghost = ((domain) => {
    if (domain == '.teld.com') {
        return 'sg'
    } else if (domain == '.qdtevc.com')
    {
        return 'perf'
    } else {
        return 'sgi'
    }
})(domain)

export const port = ((domain) => {
    if (domain == '.teld.cn' || domain == '.teld.net' || domain == '.teld.com' || domain == '.hfcdgs.com' || domain == '.qdtevc.com') {
        return ''
    }
    else if (domain == '.teld.org') {
        return ':9080'
    } else {
        return ':7777'
    }
})(domain)


// SG后缀
export const SGPOSTFIX = '/api/invoke?SID='

export const __a = '7fb498553e3c462988c3b9573692bd5f'

export const __b = '98d71fe589499967'

export const __e = 'ErYu78ijuVaM7Y0UqwvpO738uNC9ALF7'

export const __f = 'Ol9mqvZ6ijnytr7O'

export const TELDAPPID = domain == '.wyqcd.cn'  ||domain =='.teld3.top'? 'wx8034010946a8aa9f' : 'wx7c8bc1e9359f55de'

export const MALLAPPID = domain == '.wyqcd.net' ? 'wxd1cbe7a8806bda75' : 'wxbc598ad954688a19'

export const WXAUTOLOGINURL = `http://cv${domain}/module/WeChatLogin.html#/Index`



// WEBPACK FOOTER //
// ./node_modules/teld-web-component/lib/env.js